import { render, staticRenderFns } from "./ByPar.vue?vue&type=template&id=bd74da24&"
import script from "./ByPar.vue?vue&type=script&lang=js&"
export * from "./ByPar.vue?vue&type=script&lang=js&"
import style0 from "./ByPar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports